import React from "react";
import { Button, Flex, Form, Input, Modal } from "antd";
import { useFetch } from "../../Services/useFetch";
import { toast } from "react-toastify";

const ProtectedFolder = ({
  lockOpen,
  setLockOpen,
  lockData,
  protectedLockData,
  protectedSlug,
  selectedNodeData,
  setSelectedNodeData,
  fetchBriefFolderList,
}) => {
  const { request } = useFetch();
  const notify = (error) => toast.error(error);

  const handleUnlocked = async (values) => {
    try {
      if (
        protectedSlug == "lock"
          ? values?.password === values?.confirm_password
          : true
      ) {
        const formData = new URLSearchParams();
        formData.append("folder_id", protectedLockData?.key);
        formData.append("password", values?.password);
        const response =
          protectedSlug == "lock"
            ? await request("/folder-lock", "post", formData, {
                "Content-Type": "application/x-www-form-urlencoded",
              })
            : await request("/folder-unlock", "post", formData, {
                "Content-Type": "application/x-www-form-urlencoded",
              });

        if (response?.data?.status === "1") {
          setLockOpen(false);
          lockData.resetFields();
          fetchBriefFolderList(protectedLockData?.parent_id);
          const updatedChildren = selectedNodeData?.children?.map((child) => {
            if (child.key === protectedLockData.key) {
              return { ...child, is_locked: !child.is_locked };
            }
            return child;
          });
          setSelectedNodeData((prev) => ({
            ...prev,
            children: updatedChildren,
          }));

          if (protectedSlug == "unlock") {
            const unlockedFolders = JSON.parse(
              sessionStorage.getItem("unlockedFolders") || "[]"
            );
            if (!unlockedFolders.includes(protectedLockData.key)) {
              unlockedFolders.push(protectedLockData.key);
              sessionStorage.setItem(
                "unlockedFolders",
                JSON.stringify(unlockedFolders)
              );
            }
          }
        } else {
          notify(response?.response?.data?.message);
          setLockOpen(false);
          lockData.resetFields();
        }
      } else {
        notify("Password and Confirm Password do not match.");
        lockData.resetFields();
      }
    } catch (error) {
      setLockOpen(false);
      lockData.resetFields();
    }
  };

  return (
    <>
      <Modal
        title={
          protectedSlug == "lock"
            ? `protect your ${protectedLockData?.title} Folder`
            : `Get ${protectedLockData?.title} Folder Access`
        }
        open={lockOpen}
        className="bd_model_main shareModal"
        onCancel={() => {
          setLockOpen(false);
          lockData.resetFields();
        }}
        footer={null}
      >
        <Form
          name="validateOnly"
          layout="vertical"
          autoComplete="off"
          form={lockData}
          onFinish={(val) => handleUnlocked(val)}
        >
          <div className="bd_model_input">
            <Form.Item label="Password" name="password">
              <Input.Password />
            </Form.Item>
            {protectedSlug == "lock" && (
              <Form.Item label="Confirm Password" name="confirm_password">
                <Input.Password />
              </Form.Item>
            )}
          </div>

          <Flex justify="flex-end" align="center">
            <Button
              key="back"
              className="BG_ghostButton"
              onClick={() => lockData.resetFields()}
            >
              Reset
            </Button>
            <Button
              key="submit"
              className="BG_mainButton"
              style={{ marginLeft: "20px" }}
              type="primary"
              htmlType="submit"
            >
              submit
            </Button>
          </Flex>
        </Form>
      </Modal>
    </>
  );
};

export default ProtectedFolder;
